import { render } from "./Kemandirian.vue?vue&type=template&id=410cbabe"
import script from "./Kemandirian.vue?vue&type=script&lang=js"
export * from "./Kemandirian.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/aims/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__